import clsx from 'clsx'
import React from 'react'
import { formatTime } from 'utils/timeUtils'

import style from './MissionStats.module.css'

interface MissionStatsProps {
  coverage: number
  length: number
  time: number
  className?: string
}

const MissionStats: React.FC<MissionStatsProps> = ({ coverage, length, time, className }) => {
  return (
    <div className={clsx(style.missionStatsContainer, className)}>
      <div className={style.missionStatsGrid}>
        <div className={style.statCard}>
          <div className={style.statLabel}>Coverage</div>
          <div className={style.statValue}>
            {Math.round(coverage || 0)}m<sup>2</sup>
          </div>
        </div>
        <div className={style.statCard}>
          <div className={style.statLabel}>Length</div>
          <div className={style.statValue}>{Math.round(length || 0)}m</div>
        </div>
        <div className={style.statCard}>
          <div className={style.statLabel}>Exp Time</div>
          <div className={style.statValue}>{formatTime(time || 0)}</div>
        </div>
      </div>
    </div>
  )
}

export default MissionStats
